import {emotionStyled} from '@packages/utilities/styled';

export const FocusTrapView = emotionStyled('div')(
  {outline: 'none'},
  {
    componentName: 'FocusTrap',
  }
);
